export const registrationFormConfig = {
  registrationForm: [
    {
      key: "firstName",
      type: "input",
      label: "First Name",
      required: true,
      static: true,
      enabled: true,
    },
    {
      key: "lastName",
      type: "input",
      label: "Last Name",
      required: true,
      static: true,
      enabled: true,
    },
    {
      key: "email",
      type: "input",
      label: "Email",
      required: true,
      static: true,
      enabled: true,
    },
    {
      key: "confirmEmail",
      type: "input",
      label: "Confirm Email",
      required: true,
      static: true,
      enabled: true,
    },
    {
      key: "address",
      type: "input",
      label: "Address",
      required: true,
      static: true,
      enabled: true,
    },
    {
      key: "apt",
      type: "input",
      label: "Apt/Suite",
      required: false,
      static: true,
      enabled: true,
    },
    {
      key: "city",
      type: "input",
      label: "City",
      required: true,
      static: true,
      enabled: true,
    },
    {
      key: "zipcode",
      type: "input",
      label: "ZIPCODE",
      required: true,
      static: true,
      enabled: true,
    },
    {
      key: "phone",
      type: "input",
      label: "Phone",
      required: true,
      static: true,
      enabled: true,
    },
    {
      key: "companyName",
      type: "input",
      label: "Company Name",
      required: false,
      static: true,
      enabled: true,
    },
    {
      key: "custom_dropdown_1",
      type: "dropdown",
      label: {},
      required: true,
      static: false,
      enabled: true,
      options: {},
    },
    {
      key: "HowDidYouHear",
      type: "radio",
      label: "How Did You Hear",
      required: false,
      static: true,
      enabled: true,
      options: [
        { key: "email", label: "Email", enabled: true },
        { key: "phoneCall", label: "Phone Call", enabled: true },
        { key: "inPerson", label: "In Person", enabled: true },
        { key: "mailInvitation", label: "Mail Invitation", enabled: true },
        { key: "other", label: "OTHER", enabled: true },
      ],
    },
    {
      key: "iAmNotAnEmployee",
      type: "checkbox",
      label: "I am NOT and employee",
      required: true,
      static: true,
      enabled: true,
    },
    {
      key: "atLeast18",
      type: "checkbox",
      label:
        "I confirm that I am at least 18 years of age, I am a legal U.S resident of the required states for this Sweepstakes, that i have read and aggree to the {{officialRules}}, and the terms of the {{privacyPolicy}}, and that the information I have provided is accurate, and understand if the information I provided is not accurate, my entry will be void and there will be no opportunity to win a prize.",
      required: true,
      static: true,
      enabled: true,
    },
    {
      key: "iAgreePromptMsg",
      type: "checkbox",
      label: "Mail Invitation",
      required: true,
      static: true,
      enabled: true,
    },
  ],
};
